// RESET_STATE
export const RESET_STATE = 'RESET_STATE';

// FETCH_INITIAL
export const FETCH_INITIAL_PENDING = 'FETCH_INITIAL_PENDING';
export const FETCH_INITIAL_FULFILLED = 'FETCH_INITIAL_FULFILLED';
export const FETCH_INITIAL_ERROR = 'FETCH_INITIAL_ERROR';

// FETCH_PRODUCTS
export const FETCH_PRODUCTS_FULFILLED = 'FETCH_PRODUCTS_FULFILLED';
export const FETCH_SUBSCRIPTIONS_FULFILLED = 'FETCH_SUBSCRIPTIONS_FULFILLED';
export const FETCH_INVOICES_FULFILLED = 'FETCH_INVOICES_FULFILLED';

// CHECK_COUPON_CODE
export const CHECK_COUPON_CODE_PENDING = 'CHECK_COUPON_CODE_PENDING';
export const CHECK_COUPON_CODE_FULFILLED = 'CHECK_COUPON_CODE_FULFILLED';
export const CHECK_COUPON_CODE_ERROR = 'CHECK_COUPON_CODE_ERROR';

// STORE_SUBSCRIPTION
export const STORE_SUBSCRIPTION_PENDING = 'STORE_SUBSCRIPTION_PENDING';
export const STORE_SUBSCRIPTION_FULFILLED = 'STORE_SUBSCRIPTION_FULFILLED';
export const STORE_SUBSCRIPTION_ERROR = 'STORE_SUBSCRIPTION_ERROR';

// CHANGE_SUBSCRIPTION
export const CHANGE_SUBSCRIPTION_PENDING = 'CHANGE_SUBSCRIPTION_PENDING';
export const CHANGE_SUBSCRIPTION_FULFILLED = 'CHANGE_SUBSCRIPTION_FULFILLED';
export const CHANGE_SUBSCRIPTION_ERROR = 'CHANGE_SUBSCRIPTION_ERROR';

// STORE_COUPON_CODE
export const STORE_COUPON_CODE_PENDING = 'STORE_COUPON_CODE_PENDING';
export const STORE_COUPON_CODE_FULFILLED = 'STORE_COUPON_CODE_FULFILLED';
export const STORE_COUPON_CODE_ERROR = 'STORE_COUPON_CODE_ERROR';

// STORE_ADDITIONAL_COMPANY
export const STORE_ADDITIONAL_COMPANY_PENDING = 'STORE_ADDITIONAL_COMPANY_PENDING';
export const STORE_ADDITIONAL_COMPANY_FULFILLED = 'STORE_ADDITIONAL_COMPANY_FULFILLED';
export const STORE_ADDITIONAL_COMPANY_ERROR = 'STORE_ADDITIONAL_COMPANY_ERROR';

// CANCEL_SUBSCRIPTION
export const CANCEL_SUBSCRIPTION_PENDING = 'CANCEL_SUBSCRIPTION_PENDING';
export const CANCEL_SUBSCRIPTION_FULFILLED = 'CANCEL_SUBSCRIPTION_FULFILLED';
export const CANCEL_SUBSCRIPTION_ERROR = 'CANCEL_SUBSCRIPTION_ERROR';

// CHANGE_CREDIT_CARD
export const CHANGE_CREDIT_CARD_PENDING = 'CHANGE_CREDIT_CARD_PENDING';
export const CHANGE_CREDIT_CARD_FULFILLED = 'CHANGE_CREDIT_CARD_FULFILLED';
export const CHANGE_CREDIT_CARD_ERROR = 'CHANGE_CREDIT_CARD_ERROR';

// FETCH_SUBSCRIPTION_PDF
export const FETCH_SUBSCRIPTION_PDF_PENDING = 'FETCH_SUBSCRIPTION_PDF_PENDING';
export const FETCH_SUBSCRIPTION_PDF_FULFILLED = 'FETCH_SUBSCRIPTION_PDF_FULFILLED';
export const FETCH_SUBSCRIPTION_PDF_ERROR = 'FETCH_SUBSCRIPTION_PDF_ERROR';
